// removed by extract-text-webpack-plugin
module.exports = {"target":"target","file-input":"file-input","fileInput":"file-input","upload-icon":"upload-icon","uploadIcon":"upload-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/MediaUpload/MediaUploadControl.module.scss
// module id = 696
// module chunks = 0